const localeEs = {
  // Empty view
  UDE_EMPTY_TITLE: 'Aún no te has inscrito a una especialización',
  UDE_EMPTY_DESC:
    '¿Ya conoces nuestras especializaciones? Alcanza todo tu potencial con las diferentes rutas de aprendizajes que ofrecemos. Conócelas aquí.',
  // Error view
  UDE_ENROLLED_TRACKS_ERROR:
    'Ocurrió un error al obtener tus especializaciones',
  UDE_TRACKS_ERROR: 'Ocurrió un error al obtener las especializaciones',
  // Track card
  UDE_TRACK_COMPLETED: 'Especialización completada',
};
export default localeEs;
